export default function ActionBar({
    step,
    loading,
    publishing,
    regenerating,
    canGenerate,
    canPreview,
    canPublish,
    canRegenerate,
    previewError,
    isPublished = false,
    liveUrl = "",
    onBack,
    onNext,
    onSave,
    onPreview,
    onPublish,
    onRegenerate,
    onOpenLiveSite
}) {
    const hasLiveSite = Boolean(liveUrl);

    return (
        <>
            <div className="wg-action-bar">
                <div className="wg-action-left">
                    {step > 1 && (
                        <button
                            type="button"
                            className="wg-btn secondary"
                            onClick={onBack}
                        >
                            Back
                        </button>
                    )}
                </div>

                <div className="wg-action-right">
                    {step < 3 && (
                        <button
                            type="button"
                            className="wg-btn primary"
                            onClick={onNext}
                            data-qa-action="workflow-next"
                        >
                            Next
                        </button>
                    )}

                    {step === 3 && (
                        <>
                            <button
                                type="button"
                                className="wg-btn primary"
                                onClick={onSave}
                                disabled={!canGenerate || loading}
                                data-qa-action="generate-preview"
                            >
                                {loading ? "Generating..." : "Generate Website"}
                            </button>

                            <button
                                type="button"
                                className="wg-btn secondary"
                                onClick={onPreview}
                                disabled={!canPreview || loading}
                                data-qa-action="open-preview"
                            >
                                Preview
                            </button>

                            {hasLiveSite || isPublished ? (
                                <button
                                    type="button"
                                    className="wg-btn success"
                                    onClick={() => {
                                        if (onOpenLiveSite) {
                                            onOpenLiveSite();
                                            return;
                                        }

                                        if (liveUrl) {
                                            window.open(liveUrl, "_blank", "noopener,noreferrer");
                                        }
                                    }}
                                    disabled={!hasLiveSite}
                                    title={hasLiveSite ? "Open published website" : "Website is already published"}
                                >
                                    View Published Site
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="wg-btn success"
                                    onClick={onPublish}
                                    disabled={!canPublish || publishing}
                                >
                                    {publishing ? "Publishing..." : "Publish"}
                                </button>
                            )}

                            <button
                                type="button"
                                className="wg-btn ghost"
                                onClick={onRegenerate}
                                disabled={!canRegenerate || regenerating}
                            >
                                {regenerating ? "Regenerating..." : "Regenerate"}
                            </button>
                        </>
                    )}
                </div>
            </div>

            {step === 3 && previewError && (
                <div className="wg-preview-status wg-preview-status-error">
                    {previewError}
                </div>
            )}
        </>
    );
}